var _pattern, _rect, _path, _path2, _path3, _rect2, _path4, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 336,
    height: 204,
    viewBox: "0 0 336 204",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _pattern || (_pattern = /*#__PURE__*/React.createElement("pattern", {
    id: "a",
    width: 6.6,
    height: 6.6,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9FA",
    d: "M0 0h6.6v6.6H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.3,
    cy: 3.3,
    r: 0.5,
    fill: "#D5D6E0"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 336,
    height: 204,
    fill: "url(#a)",
    rx: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF50A4",
    d: "M55.6 30.5 49 24 24.1 49l6.5 6.4 25-24.9Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#04E1FF",
    d: "M116.4 57.3a8 8 0 0 1 8-7.3h110a8 8 0 0 1 8 8.6l-6.8 87.5a8 8 0 0 1-8.5 7.4l-110-7a8 8 0 0 1-7.4-8.6l6.7-80.6Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#08124C",
    d: "M30.6 61.1 24 54.5l24.9-24.9 6.6 6.6-25 24.9ZM26 54.5l4.5 4.5 22.7-22.7-4.5-4.5L26 54.5ZM304 188a5 5 0 0 1-3.7-1.6 5 5 0 0 1 0-7.2c2-2 5.2-2 7.2 0s2 5.2 0 7.2a5 5 0 0 1-3.6 1.5Zm-2.3-7.4a3.2 3.2 0 0 0 0 4.5 3.2 3.2 0 0 0 4.5 0 3.2 3.2 0 0 0 0-4.5 3.2 3.2 0 0 0-4.5 0Zm-10.9-5.8a5.1 5.1 0 0 1-3.6-8.7c2-2 5.2-2 7.2 0a5.2 5.2 0 0 1 0 7.3 5 5 0 0 1-3.6 1.4Zm-2.2-7.4a3.2 3.2 0 0 0 0 4.6 3.2 3.2 0 0 0 4.5 0 3.2 3.2 0 0 0 0-4.5 3.2 3.2 0 0 0-4.5 0Zm-10.9-5.7a5 5 0 0 1-3.6-1.5 5 5 0 0 1 0-7.2 5 5 0 0 1 3.6-1.5 5 5 0 0 1 3.6 1.5c2 2 2 5.2 0 7.2a5 5 0 0 1-3.6 1.5Zm-2.3-7.4a3.2 3.2 0 0 0 0 4.6 3.2 3.2 0 0 0 4.6 0 3.2 3.2 0 0 0 0-4.6 3.2 3.2 0 0 0-4.6 0Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 134,
    height: 96,
    x: 101,
    y: 58,
    fill: "#08124C",
    rx: 8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF8F28",
    d: "M310.4 176.4a5 5 0 0 0-7 0 5 5 0 0 0 7.1 7.1c2-2 2-5.1 0-7.1Zm-13.1-13.1a5 5 0 0 0-7.1-.1 5 5 0 0 0 7.2 7.2c2-2 2-5.2 0-7.2Zm-13.1-13.2a5 5 0 0 0-7.1 0 5 5 0 0 0 7.1 7.2c2-2 2-5.2 0-7.2Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#DEBAFF"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 148,
    cy: 98,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 188,
    cy: 98,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.5 110.6c.7.8.7 2 0 2.8a16.5 16.5 0 0 1-22.9 0c-.8-.7-.8-2 0-2.8.6-.8 1.8-.8 2.5 0a13.4 13.4 0 0 0 17.7 0c.8-.8 2-.8 2.7 0Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.a566f8cb04d63cf539339b2b810e8106.svg";
export { ForwardRef as ReactComponent };